// extracted by mini-css-extract-plugin
module.exports = {"cartShippingAddressDisplay":"cart-shipping-address-display_cartShippingAddressDisplay__8PIwa","address":"cart-shipping-address-display_address__14a9m"};